import { MtxButton } from '@meilleurtaux/mtp-uikit-react';
import { useTranslation } from 'react-i18next';

import iconTraitement from '@/assets/images/iconTraitement.svg';
import { FamilleCardReprendreSouscription } from '@/components/Dico';
import Image from '@/components/Image/Image';

import styles from './styles.module.css';

type Props = {
  titreProduit: string;
  iconAssurance: string;
  famille: string | null | undefined;
  cancelablePeriod?: number | null;
  onRequestCancellation?: () => void;
};

const CardInProgress = ({ famille, titreProduit, iconAssurance, cancelablePeriod, onRequestCancellation }: Props) => {
  const { t } = useTranslation();
  const cancelLabel = cancelablePeriod === 14 ? t('common.retractableCTA') : t('common.cancelableCTA');
  return (
    <div className={styles.boxCardInProgress}>
      <div className={styles.cardInProgressTitleLogo}>
        <span>{FamilleCardReprendreSouscription[famille as keyof typeof FamilleCardReprendreSouscription]}</span>
        <div
          className={styles.partnerLogo}
          style={{
            backgroundImage: `url('${iconAssurance}')`,
          }}
        ></div>
      </div>
      <p className={styles.inProgressProductName}>{titreProduit}</p>
      <div className={styles.inProgressStatus}>
        <Image defaultSrc={iconTraitement} alt="En cours de Traitement" />
        <p className={styles.colorTextStatus}>En cours de traitement </p>
      </div>
      {onRequestCancellation && (
        <div className={styles.inProgressStatus}>
          <MtxButton variant="tertiary" size="small" onClick={onRequestCancellation}>
            {cancelLabel}
          </MtxButton>
        </div>
      )}
    </div>
  );
};

export default CardInProgress;
